var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-app": "" } },
    [
      _c("div", { staticClass: "flex-vertical photo-area-container" }, [
        _c("div", { staticClass: "flex-vertical photo-container" }, [
          _vm.photoUploaded
            ? _c(
                "div",
                {
                  staticClass: "photo-image fill-space",
                  on: { click: _vm.openImageDialog }
                },
                [
                  _c("img", {
                    staticClass: "photo fill-space",
                    attrs: {
                      src: _vm.getPhotoWithBase64(
                        _vm.selectedPhoto.image_thumb
                      ),
                      alt: "photo"
                    }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.photoUploaded && !_vm.disabled
            ? _c(
                "div",
                { staticClass: "flex-vertical photo-options" },
                [
                  _c("MenuButton", {
                    staticClass: "photo-options-button",
                    on: {
                      click: function($event) {
                        _vm.hoverMenu = !_vm.hoverMenu
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("photo-menu", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hoverMenu,
                        expression: "hoverMenu"
                      }
                    ],
                    on: {
                      updateImage: _vm.onFileChange,
                      removeImage: _vm.tryToDeletePhoto
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.photoUploaded
            ? _c(
                "div",
                {
                  staticClass: "input-container fill-space",
                  class: { disabled: _vm.disabled },
                  style: { "background-image": "url(" + _vm.photoIcon + ")" },
                  on: { change: _vm.onFileChange }
                },
                [
                  _c("input", {
                    staticClass: "photo-input fill-space",
                    attrs: {
                      type: "file",
                      accept: "image/*",
                      title: "",
                      disabled: _vm.disabled
                    }
                  })
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "photo-name" }, [
          _vm._v(_vm._s(_vm.imageData.label))
        ])
      ]),
      _vm._v(" "),
      _vm.imageDialog
        ? _c("photo-opened", {
            attrs: {
              imageData: _vm.imageData,
              image: _vm.selectedPhoto.image,
              thumb: _vm.selectedPhoto.image_thumb,
              description: _vm.selectedPhoto.description,
              uuid: _vm.selectedPhoto.uuid,
              disabled: _vm.disabled,
              photoCanBeClosed: _vm.photoCanBeClosed
            },
            on: {
              removeImage: _vm.tryToDeletePhoto,
              close: _vm.closeImageDialog,
              updateDescription: _vm.updateDescription
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("photo-upload-error", {
        attrs: {
          toggleDialog: _vm.uploadErrorDialog,
          specificErrorMessage: _vm.$t(_vm.specificErrorMessage)
        }
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.deleteDialogIsOpen,
          title: _vm.$t("DeletePhoto"),
          content: _vm.$t("DeletePhotoConfirmation"),
          "main-action-label": _vm.$t("Yes"),
          "secondary-action-label": _vm.$t("No")
        },
        on: {
          mainAction: _vm.removeImage,
          secondaryAction: function($event) {
            _vm.deleteDialogIsOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dbb2ece2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbb2ece2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Photos/PhotoField.vue
// module id = null
// module chunks = 